import * as React from "react";
import {
  Stack,
  CompoundButton,
  FontIcon,
  FontSizes,
  PrimaryButton,
  ProgressIndicator,
} from "@fluentui/react";
import { useContext, useEffect, useRef, useState } from "react";
import MicrosoftLogin from "react-microsoft-login";
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../auth/context/auth-context";
import { IMicrosoft } from "../../auth/interface/IAuth";
import AuthService from "../../services/AuthService";
import { LOGO_MMG, LOGO_TESEO, stackTokens } from "../../utils/Helper/helper";
import ThemeBase from "../../utils/Theme/themeBase";
import { ConfigHelper } from "../../utils/Helper/configHelper";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../utils/Helper/autConfig";
import { ButtonLoginMicrosoft } from "../../components/Login/ButtonLoginMicrosoft";
import { siteKey } from "../../services/http-common";

interface TokenClaims {
  [key: string]: any;
}

declare global {
  interface Window {
    grecaptcha: {
      enterprise: {
        execute: (
          siteKey: string,
          options: { action: string }
        ) => Promise<string>;
      };
    };
  }
}

export const Home = ({ toggleHome = () => { } }) => {
  const navigate = useNavigate();
  const { signin } = useContext(AuthContext);
  const [loginDisabled, setLoginDisabled] = useState(false); // cambiar estado para habilitar botones de login
  const [isLoginInProgress, setIsLoginInProgress] = useState(false);
  const [loginProgresMicrosoft, setLoginProgresMicrosoft] = useState(false);

  const captchaRef = useRef<HCaptcha>(null);
  
  const { instance: msalInstance } = useMsal();
  
  const onLoad = () => {
    // https://docs.hcaptcha.com/configuration#jsapi
    if (captchaRef != null) {
      captchaRef?.current?.execute();
    }
  };

  const handleLoginClickMS = async () => {
    try {
      setLoginProgresMicrosoft(true); // Inicia progreso al hacer click
      await msalInstance.loginRedirect({
        ...loginRequest,
        prompt: "select_account",
      });
    } catch (error) {
      setLoginProgresMicrosoft(false); // Si falla, termina progreso
      console.error("❌ Login failed!", error);
    }
  };

  const [exp, setExp] = useState(0);
  const [verLoading, setVerLoading] = useState(false);
  const [excepcion, setExcepcion] = useState(null);

  // const _handleLoginMicrosoft = (token: IMicrosoft) => {
  //   setIsLoginInProgress(false);
  //   setVerLoading(true);
  //   AuthService.loginMicrosoft(token)
  //     .then((response) => {
  //       if (response.status == 200) {
  //         let res = JSON.parse(response.request.response);
  //         if (res.succeeded) {
  //           setExcepcion(null);
  //           if (res.accessToken != undefined && res.accessToken !== "") {
  //             signin(
  //               {
  //                 username: token.unique_name,
  //                 token: res.accessToken,
  //               },
  //               () => navigate(ConfigHelper.urlBase(true), { replace: true })
  //             );
  //           }
  //         } else {
  //           setExcepcion(res.exception);
  //         }
  //       }
  //       setVerLoading(false);
  //     })
  //     .catch((e: Error) => {
  //       console.log(e);
  //       if (e != undefined) {
  //         setExcepcion(e.message as any);
  //       }
  //       setVerLoading(false);
  //     });
  // };

  const _handleLoginMicrosoft = (token: IMicrosoft) => {
    setVerLoading(true);
    setLoginProgresMicrosoft(true)
    AuthService.loginMicrosoft(token)
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          let res = JSON.parse(response.request.response);
          if (res.succeeded) {
            setExcepcion(null);
            if (res.accessToken !== undefined && res.accessToken !== "") {
              signin(
                {
                  username: token.unique_name,
                  token: res.accessToken,
                },
                () => navigate(ConfigHelper.urlBase(true), { replace: true })
              );
            }
          } else {
            setExcepcion(res.exception);
          }
        }
        setVerLoading(false);
        setLoginProgresMicrosoft(false)
      })
      .catch((e: Error) => {
        console.log(e);
        if (e !== undefined) {
          setExcepcion(e.message as any);
        }
        setVerLoading(false);
        setLoginProgresMicrosoft(false)
      });
    console.log(excepcion);
  };

  const styleInDisabled = {
    border: "1px solid #faf9f8",
    backgroundColor: "#ffffff",
    color: "#333333",
  };

  const [tReCaptcha, setTReCaptcha] = useState("");

  // const handleSubmit = (event: React.FormEvent) => {
  //   event.preventDefault();

  //   // Aquí puedes verificar la respuesta del reCaptcha y enviar el formulario
  //   window.grecaptcha.enterprise
  //     //.execute("6Lf5lCMpAAAAAEuGVqC2ET6DtxQ_siYhvjoT4zVM", { action: "submit" })
  //     .execute("6Le2AzMpAAAAAE1QA-tdoJxLiOH2Yz7CN-JtILrV", { action: "submit" })
  //     .then((token: string) => {
  //       // Aquí puedes verificar la respuesta del reCaptcha utilizando el token
  //       if (token) {
  //         // El reCaptcha se ha completado, puedes enviar el formulario
  //         // También puedes enviar el token a tu servidor para su verificación adicional si es necesario
  //         //console.log("Token de reCaptcha:", token);
  //         setTReCaptcha(token);
  //         // Aquí puedes enviar el formulario o realizar otras acciones
  //       } else {
  //         // El reCaptcha no se ha completado, puedes mostrar un mensaje de error
  //         console.log("El reCaptcha no se ha completado");
  //       }
  //     });
  // };

  useEffect(() => {
    const container = document.getElementById("recaptcha-container");
    if (container) {
      // Inicializar reCaptcha aquí
      const script = document.createElement("script");
      // script.src =
      //   "https://www.google.com/recaptcha/enterprise.js?render=6Lf5lCMpAAAAAEuGVqC2ET6DtxQ_siYhvjoT4zVM";
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`;
      script.async = true;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, []);

  // Luego, cuando el usuario vuelve del redirect, obtienes el token:
  const handleAfterRedirect = async () => {
    try {
      // 🟢 Aseguramos que está inicializado correctamente
      // -> await msalInstance.initialize();

      const redirectResult = await msalInstance.handleRedirectPromise();

      if (redirectResult) {
        msalInstance.setActiveAccount(redirectResult.account);
        console.log(
          "✅ Usuario activo desde redirect:",
          redirectResult.account?.username
        );
      }

      let account = msalInstance.getActiveAccount();
      if (!account) {
        const allAccounts = msalInstance.getAllAccounts();
        if (allAccounts.length > 0) {
          account = allAccounts[0];
          msalInstance.setActiveAccount(account);
          console.log("✅ Usuario activo desde caché:", account.username);
        }
      }

      if (!account) {
        console.warn("⚠️ No hay cuenta activa después del redirect.");
        return;
      }

      const tokenResponse = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account,
      });
      //console.log("✅ Access Token obtenido:", tokenResponse);
      const tokenReceived: IMicrosoft = {
        appid: tokenResponse.account.idTokenClaims?.aud ?? "",
        exp: tokenResponse.account?.idTokenClaims?.exp ?? 0,
        unique_name:
          tokenResponse.account?.idTokenClaims?.preferred_username ?? "",
        token: tokenResponse.accessToken, // This is the crucial part - passing the access token
      };
      // _handleLoginMicrosoft({ token: tokenResponse.accessToken });
      _handleLoginMicrosoft(tokenReceived);
    } catch (error) {
      console.error("❌ Error al manejar redirect:", error);
    }
  };

  useEffect(() => {
    const init = async () => {
      // -> await msalInstance.initialize();
      handleAfterRedirect();
    };
    init();
  }, []);

  return (
    <>
      {/* <div id="recaptcha-container">
        <form onSubmit={handleSubmit}>
          <br></br>
          <Stack tokens={stackTokens}>
            <PrimaryButton
              ariaDescription="Detailed description used for screen reader."
              type="submit"
              //onClick={_handleLogin}
            >
              Ingresar
            </PrimaryButton>
          </Stack>
        </form>
      </div> */}
      <div
        style={{
          height: "100vh",
          backgroundColor: ThemeBase.theme.palette.neutralLighter,
        }}
      >
        <div
          style={{
            display: "flex",
            paddingTop: "5%",
          }}
        >
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                <div style={ThemeBase.parentFlexEnd}>
                  <div
                    style={{
                      marginLeft: "auto",
                      color: "red",
                    }}
                  >
                    <img
                      style={{
                        height: "50px",
                        width: "90px",
                      }}
                      src={LOGO_MMG}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                <div
                  style={{
                    paddingRight: "10px",
                    paddingLeft: "15px",
                  }}
                >
                  <div style={{ fontSize: FontSizes.size24 }}>Bienvenido</div>
                  <br />
                  <br />
                  <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg2">
                        Cliente:
                      </div>
                      <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg10">
                        MMG Las Bambas
                      </div>
                    </div>
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg2">
                        Proceso:
                      </div>
                      <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg10">
                        Movilización Sanitaria
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {!loginProgresMicrosoft && (
                <div
                  className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
                  style={{
                    // ...ThemeBase.justifiedStyle,
                    paddingTop: "15%",
                  }}
                >
                  <Stack horizontal tokens={stackTokens}>
                    <div
                    //style={{ pointerEvents: loginDisabled ? "none" : "auto" }}
                    >
                      <ButtonLoginMicrosoft onclick={handleLoginClickMS} />
                    </div>

                    <div id="recaptcha-container">
                      <CompoundButton
                        secondaryText=""
                        //disabled={loginDisabled}
                        checked={false}
                        onClick={toggleHome}
                        // styles={!loginDisabled ? ThemeBase.buttonHome : {}}
                        styles={ThemeBase.buttonHome}
                        // style={loginDisabled ? styleInDisabled : {}}
                        style={{}}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            <FontIcon
                              aria-label={"Group"}
                              iconName={"Group"}
                              className={ThemeBase.classes.icon}
                            />
                            <div>SSEE</div>
                          </div>
                        </div>
                      </CompoundButton>
                    </div>
                  </Stack>
                  <br />
                  {/* <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg2">
                      <HCaptcha
                        sitekey="2134267e-63e8-46c6-bb2f-be36b137ae1e"
                        ref={captchaRef}
                        onLoad={onLoad}
                        onVerify={onVerifyCaptcha}
                        languageOverride="es"
                        size="normal"
                        theme="dark"
                      />
                    </div>
                  </div> */}
                </div>
              )}
              {loginProgresMicrosoft && (
                <>
                  <div
                    className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
                    style={{
                      // ...ThemeBase.justifiedStyle,
                      paddingTop: "15%",
                    }}
                  >
                    <ProgressIndicator
                      barHeight={5}
                      label="Enviando información"
                      description="Favor Espere un momento"
                    />
                  </div>
                </>
              )}
            </div>

            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />

            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                <div style={ThemeBase.parentFlexEnd}>
                  <div
                    style={{
                      marginLeft: "auto",
                      color: "red",
                    }}
                  >
                    <img
                      style={{
                        height: "65px",
                        width: "65px",
                      }}
                      src={LOGO_TESEO}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
